var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Button',{staticClass:"p-button p-button-text p-button-secondary",attrs:{"aria-label":_vm.$t('global.back').toString(),"icon":"pi pi-arrow-left","data-cy":"back-button"},on:{"click":function($event){return _vm.onClick()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }